import { Icon } from "../icon/icon";

export const ProfileIcon = ({
  img,
  dimension = 32,
  className = "",
}: {
  img?: string;
  dimension?: number;
  className?: string;
}) => {
  return img ? (
    <img
      src={img}
      alt="profile"
      style={{
        width: `${dimension}px`,
        minWidth: `${dimension}px`,
        maxWidth: `${dimension}px`,
        height: `${dimension}px`,
        minHeight: `${dimension}px`,
        maxHeight: `${dimension}px`,
      }}
      className={`block rounded-full ${className}`}
    />
  ) : (
    <span
      style={{
        width: `${dimension}px`,
        minWidth: `${dimension}px`,
        maxWidth: `${dimension}px`,
        height: `${dimension}px`,
        minHeight: `${dimension}px`,
        maxHeight: `${dimension}px`,
      }}
      className={`flex items-center justify-center rounded-full bg-grey-100 p-[6px] text-black ${className}`}
    >
      <Icon
        svg="avatar"
        width={dimension - 6}
        height={dimension - 6}
        className="h-full w-full"
      />
    </span>
  );
};
